import React, {Fragment} from 'react';
// import PageTitle from '../../components/pagetitle/PageTitle';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Contactpage from '../../components/Contactpage/Contactpage';
import { Helmet } from 'react-helmet';

const ContactPage =() => {
    return(
        <Fragment>
            <Helmet>
                <title>Contact | Up Dental of Manvel TX</title>
                <meta name="description" content="Contact | Up Dental of Manvel TX" />
                <meta name="keywords" content="dental, dentist, Manvel, treatment, patients, office, appointment" />
            </Helmet>
            <Navbar hclass={"wpo-header-style-2"}/>
            {/* <PageTitle pageTitle={'Contact Us'} pagesub={'Contact'} className={'wpo-page-title'}/>  */}
            <Contactpage/> 
            <Footer footerClass={'wpo-site-footer-s2'}/>
            <Scrollbar/>
        </Fragment>
    )
};

export default ContactPage;

